let inMemoryRepo = [];

export function saveEmployeeSelection({ ids }) {
  inMemoryRepo = [...ids];
}

export function findEmployeesSelection() {
  return inMemoryRepo;
}

export function removeEmployeesSelection({ ids }) {
  inMemoryRepo = inMemoryRepo.filter((id) => !ids.includes(id));
}
